export default {
  HEADER: 'header',
  SECTION: 'section',
  FIELD: 'field',
  FIELD_GROUP: 'group',
};
